import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { visibleMarkersMapSelector, markerDetailViewSelector, markersSelector } from '../../../features/places/placesSlice';
import { setNeedBounding, setCenter, setZoom, resetMapDefault } from '../../../features/map/mapSlice';

const GoogleMapMarkerBounder = ({ map }) => {
    const dispatch = useDispatch();
    const visibleMarkersMap = useSelector(visibleMarkersMapSelector);
    const markerDetailView = useSelector(markerDetailViewSelector);
    const markers = useSelector(markersSelector)


    useEffect(() => {
        const mapBounder = () => {
            if (map && window.google && !markerDetailView) {
                if (visibleMarkersMap.length > 1) {
                    let bounds = new window.google.maps.LatLngBounds();

                    visibleMarkersMap.forEach(vz => {
                        let point = new window.google.maps.LatLng(
                            parseFloat(markers[`${vz}`].marker_coords.lat),
                            parseFloat(markers[`${vz}`].marker_coords.lng),
                        );
                        bounds.extend(point)
                    });
                    map.fitBounds(bounds, { left: 350, bottom: 100, top: 75, right: 25 });
                } else if (visibleMarkersMap.length === 1) {
                    dispatch(setCenter({
                        lat: parseFloat(markers[`${visibleMarkersMap[0]}`].marker_coords.lat),
                        lng: parseFloat(markers[`${visibleMarkersMap[0]}`].marker_coords.lng),
                    }));
                    dispatch(setZoom(17));
                } else {
                    dispatch(resetMapDefault());
                }

                dispatch(setNeedBounding(false));

            };
        };
        mapBounder();
    }, [dispatch, map, visibleMarkersMap, markerDetailView, markers]);

    return (
        <div></div>
    );
}

export default GoogleMapMarkerBounder;